import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {
      isLoading: false,
      orderMultipleModal: {
        name: 'orderMultiple',
        path: 'Cart/ModalOrderMultiple',
        title: 'Komunikat',
        buttons: [{ action: 'closeModal', text: 'Anuluj', theme: 'lightPurple', space: 'left' }],
      },
      basketOrderMultipleModal: {
        name: 'basketOrderMultiple',
        path: 'Cart/ModalBasketOrderMultiple',
        title: 'Komunikat',
        buttons: [{ action: 'closeModal', text: 'Ok', theme: 'lightPurple', space: 'left' }],
      },
    };
  },
  computed: {
    ...mapState({
      shoppingCart: state => state.cart.shoppingCart,
      orderCart: state => state.cart.orderCart,
      editOrderId: state => state.cart.editOrderId,
    }),
    cartData() {
      if (this.editOrderId && this.orderCart && this.orderCart.items.length) {
        return this.orderCart;
      } else {
        return this.shoppingCart;
      }
    },
  },
  methods: {
    ...mapMutations({
      setCart: 'cart/setCart',
      pushModal: 'modal/pushModal',
      setAgeInformationPopupShow: 'layout/setAgeInformationPopupShow',
      setAgeInformationPopupAddToCartInfo: 'layout/setAgeInformationPopupAddToCartInfo',
    }),
    ...mapActions({
      storeAddProductToCart: 'cart/addProductToCart',
      storeAddProductsToCart: 'cart/addProductsToCart',
      deleteProductFromCart: 'cart/deleteProductFromCart',
      getCart: 'cart/getCart',
      storeUpdateProductsAmount: 'cart/updateProductsAmount',
      updatePromoCode: 'cart/updatePromoCode',
      clearBasket: 'cart/clearBasket',
      deleteProductsFromCart: 'cart/deleteProductsFromCart',
    }),
    async updateProductsAmount(
      product,
      count,
      orderMultiple = false,
      orderQuantityMultiple,
      disablePopup,
      listName,
    ) {
      if (orderMultiple && count % orderQuantityMultiple) {
        await this.pushModal({
          modal: this.basketOrderMultipleModal,
          data: { product, count, orderMultiple, orderQuantityMultiple },
        });
      } else {
        await this.storeUpdateProductsAmount({ product, count, disablePopup, listName });
      }
    },
    getProductQuantity(productId, items) {
      let item = null;
      if (items && items.length) {
        item = items.find(item => {
          return item.id === productId;
        });
        return item ? item.quantity : 0;
      }

      return 0;
    },
    async addProductToCart(product, count, isModal, listName) {
      if (!product.orderQuantityMultipleSuggestedOnly && count % product.orderQuantityMultiple) {
        if (!isModal) {
          await this.pushModal({
            modal: this.orderMultipleModal,
            data: { product },
          });
        }
      } else {
        if (isModal) {
          await this.$emit('closeAllModals');
        }

        const ageInformationPopupCookie = this.$cookies.get('ageInformationPopup');

        if (product?.category?.forAdults && !ageInformationPopupCookie) {
          this.setAgeInformationPopupShow(true);
          this.setAgeInformationPopupAddToCartInfo({ product, count, isModal, listName });
        } else {
          await this.storeAddProductToCart({ product, count, listName });
        }
      }
    },
  },
};
